export default "__VITE_ASSET__DJMZh6yc__"